/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { SplitViewComponent } from './split-view';
export * from './split-view-adapter';
export * from './split-view-constants';
export * from './split-view-core';
export * from './split-view';
export function defineSplitViewComponent() {
    defineCustomElement(SplitViewComponent);
}
